// extracted by mini-css-extract-plugin
export var listItemFormatting = "styles-module--list-item-formatting--MvHmp";
export var disclosure = "styles-module--disclosure--3SvGh";